'use client'

import React, { useEffect, useState } from 'react'
import { Map as MapLibreMap, MapProvider } from 'react-map-gl/maplibre'
import { Protocol } from 'pmtiles'
import maplibregl from 'maplibre-gl'
import { layers, LIGHT } from '@protomaps/basemaps'
import 'maplibre-gl/dist/maplibre-gl.css'
import { useIsMobile } from '@/hooks/use-mobile'

function Map({
  interactive = true,
  children,
  initialViewState,
}: {
  interactive?: boolean
  children: React.ReactNode
  initialViewState: {
    longitude: number
    latitude: number
    zoom: number
  }
}) {
  const [viewState, setViewState] = useState(initialViewState)
  const isMobile = useIsMobile()

  useEffect(() => {
    if (isMobile && initialViewState.zoom !== 12) {
      setViewState({ latitude: 62.71888203885151, longitude: 12.301292273228823, zoom: 3.5 })
    }
  }, [initialViewState.zoom, isMobile])

  useEffect(() => {
    const protocol = new Protocol()
    maplibregl.addProtocol('pmtiles', protocol.tile)

    return () => {
      maplibregl.removeProtocol('pmtiles')
    }
  }, [])

  return (
    <MapProvider>
      <MapLibreMap
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#80deea',
          position: 'absolute',
        }}
        cooperativeGestures
        {...viewState}
        onMove={(e) => {
          setViewState(e.viewState)
        }}
        mapStyle={{
          sprite: 'https://protomaps.github.io/basemaps-assets/sprites/v4/light',
          glyphs: 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf',
          version: 8,

          sources: {
            protomaps: {
              type: 'vector',
              url: 'pmtiles://https://map-tiles-cache.hi-6df.workers.dev/first-hotels-maptiles-v2.pmtiles',
              // url: 'pmtiles://https://dlswxyfpgnorngtyexoo.supabase.co/storage/v1/object/public/public-map/first-hotels-maptiles.pmtiles',
            },
          },

          layers: [
            {
              id: 'background',
              type: 'background',
              paint: {
                'background-color': '#80deea',
              },
            },
            ...layers('protomaps', LIGHT).filter((l) => l.id !== 'background'),
          ],
        }}
        attributionControl={false}
        // reuseMaps
        mapLib={maplibregl}
        interactive={interactive}
      >
        {children}
      </MapLibreMap>
    </MapProvider>
  )
}

export default Map
